<div class="loaderContent">
  <ngx-ui-loader [loaderId]="componentID"></ngx-ui-loader>

  <dx-toolbar style="margin-bottom: 10px">
    <dxi-item location="before">
      <dx-button text="Add" (onClick)="onAdd()" icon="{{ env.assetsPath }}images/Add_16x16.png"></dx-button>
    </dxi-item>
    <dxi-item location="before">
      <dx-button
        text="Refersh"
        (onClick)="onRefresh()"
        icon="{{ env.assetsPath }}images/Refresh_16x16.png"
      ></dx-button>
    </dxi-item>
    <dxi-item location="after">
      <dx-button
        text="Close"
        type="normal"
        (onClick)="closeView()"
        icon="{{ env.assetsPath }}images/LogOut_16x16.png"
      ></dx-button>
    </dxi-item>
  </dx-toolbar>

  <div class="border dx-theme-border-color-grid">
    <dx-data-grid
      #searchgrid
      [dataSource]="dataSource"
      rowAlternationEnabled="true"
      [columnAutoWidth]="true"
      width="auto"
      >
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[15, 30, 100, 500]" [showInfo]="true">
      </dxo-pager>

      <dxi-column alignment="center" cellTemplate="infoTemplate" width="30px"></dxi-column>
      <dxi-column
        dataField="is_active"
        caption="Active"
        cellTemplate="activeTemplate"
        width="auto"
        alignment="center"
      ></dxi-column>
      <dxi-column dataField="user_name" caption="User Name" cellTemplate="linkTemplate" width="auto"></dxi-column>
      <dxi-column dataField="user_code" caption="User Code" width="auto"></dxi-column>
      <dxi-column dataField="agency_name" caption="Agency" width="auto"></dxi-column>
      <dxi-column dataField="first_name" caption="First Name" width="auto"></dxi-column>
      <dxi-column dataField="last_name" caption="Last Name" width="auto"></dxi-column>
      <dxi-column dataField="email" caption="Email" width="auto"></dxi-column>
      <dxi-column dataField="phone1" caption="Phone" width="auto"></dxi-column>
      <dxi-column dataField="phone2" caption="Alt Phone" width="auto"></dxi-column>

      <dxo-summary>
        <dxi-total-item column="user_name" summaryType="count" displayFormat="{0}"></dxi-total-item>
      </dxo-summary>

      <div *dxTemplate="let data of 'activeTemplate'">
        @if (data.data.is_active) {
          <img src="{{ env.assetsPath }}images/Check Green Circle - 16x16.png" />
        }
      </div>
      <div *dxTemplate="let data of 'linkTemplate'">
        <a routerLink="/user/edit/{{ data.data.user_id }}">{{ data.data.user_name }}</a>
      </div>
      <div *dxTemplate="let data of 'infoTemplate'">
        <img
          [id]="'imgInfo' + data.data.user_id"
          style="cursor: pointer"
          src="{{ env.assetsPath }}images/Information_16x16.png"
          />
          <dx-tooltip [target]="'#imgInfo' + data.data.user_id" showEvent="dxclick">
            <div *dxTemplate="let data2 = data2; of: 'content'">
              <span style="font-weight: bold">{{ data.data.user_name }} - {{ data.data.first_last }}</span>
              <table>
                <tr>
                  <td class="grid-label" style="text-align: left">Email</td>
                  <td class="grid-value" style="text-align: left">{{ data.data.email }}</td>
                </tr>
                <tr>
                  <td class="grid-label" style="text-align: left">Phone</td>
                  <td class="grid-value" style="text-align: left">{{ data.data.phone1 }}</td>
                </tr>
                <tr>
                  <td class="grid-label" style="text-align: left">Alt Phone</td>
                  <td class="grid-value" style="text-align: left">{{ data.data.phone2 }}</td>
                </tr>
              </table>
            </div>
          </dx-tooltip>
        </div>
      </dx-data-grid>
    </div>
  </div>
